import { ContextContainer } from '../../core/ContextContainer';
import { UploaderError } from '../../errors/UploaderError';
import { MAX_EXECUTION_NUMBER } from '../../globals/constant';
export class AbstractTask extends ContextContainer {
    constructor(context) {
        super(context);
        this.executionNumber = 0;
        this.maxExecutionNumber = MAX_EXECUTION_NUMBER;
        this.delay = 0;
        this.sdkFatalErrors = [];
        this.error = null;
    }
    isFirstTask() {
        return false;
    }
    isLastTask() {
        return false;
    }
    execute() {
        this.clearError();
        return this.process().then(Task => {
            this.executionNumber++;
            return Task;
        });
    }
    isOnError() {
        return Boolean(this.error);
    }
    clearError() {
        this.error = null;
        return this;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError('SDK Unrecoverable Error'));
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError('Unrecoverable Error'));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
    setDelay(delay) {
        this.delay = delay;
        return this;
    }
}
